<template>
  <div class="bg-loginimg">
    <div class="container" id="login-form">
      <div class="row">
        <div class="col-md-4 col-md-offset-4">
          <div class="panel panel-default login-ragis-formstylechen-aftersell">

            <div class="panel-body asloginvew">
              <div class="loginheader">
                  <a href="#" class="login-logo"
                    ><img :src="logo"
                  /></a>
                </div>
                  <router-view></router-view>
            </div>
            
          </div>
        </div>
      </div>

      <div class="copyright">
        <p class="center">
          Copyright 2021, GladMinds Technologies Pvt Ltd. All Right Reserved.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import commonServices from '../../services/common-services';
export default {
  name: 'PasswordReset',
  beforeCreate() {
    this.$store.commit('SET_LAYOUT', 'simple-layout');
  },
  computed: {
    logo () {
      return commonServices.asset_url('assets/img/logo-dark.png');
    }
  }
 
};
</script>

